import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { VWProgram } from '@app/core/models';
import { AppState, selectProgram } from '@app/core/ngrx';

@Component({
  selector: 'ecp-collection-price-formula',
  templateUrl: './collection-price-formula.component.html',
  styleUrls: ['./collection-price-formula.component.scss'],
})
export class CollectionPriceFormulaComponent implements OnInit {
  // @select(['user', 'profile', 'program'])
  public program$: Observable<VWProgram>;
  theme = 'one-portal';
  public moduleName: any = null;
  public framesList: any = null;
  public priceSelections = [
    { priceValue: 'wholesalePrice', priceName: 'Wholesale Price' },
    { priceValue: 'purchasePrice', priceName: 'Purchase Price' },
  ];
  public isReplaceShown = false;
  private id: any;
  private endingDigits: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CollectionPriceFormulaComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
    if (data.hasOwnProperty('values')) {
      this.moduleName = data.values.hasOwnProperty('moduleName') ? data.values.moduleName : null;
      this.framesList = data.values.hasOwnProperty('framesList') ? data.values.framesList : null;
      this.id = data.values.clusterId || data.values.moduleId;
    }
  }

  get multiplier(): AbstractControl {
    return this.formulaForm.get('multiplier');
  }

  get addition(): AbstractControl {
    return this.formulaForm.get('addition');
  }

  get replace(): AbstractControl {
    return this.formulaForm.get('replace');
  }

  get priceType(): AbstractControl {
    return this.formulaForm.get('priceType');
  }

  formulaForm: FormGroup;

  toggleReplaceDisplay() {
    this.isReplaceShown = !this.isReplaceShown;

    if (this.isReplaceShown) {
      this.replace.setValidators([
        Validators.required,
        Validators.pattern('^\\$([0-9]|X)?\\.([0-9]X|X[0-9]|[0-9]{2}$)'),
      ]);
    } else {
      this.replace.setValidators(undefined);
    }
    this.replace.updateValueAndValidity();
  }

  closeDialog(isApply): void {
    if (isApply) {
      let frames = this.getPrice();
      this.dialogRef.close({
        frameList: frames,
        retailPricingFormula: {
          moduleId: this.id,
          formula: JSON.stringify({
            multiplier: this.multiplier.value,
            replaceEndingDigits: !!this.replace.value,
            endingDigits: this.endingDigits ? this.endingDigits : undefined,
            addition: this.addition.value,
            price: this.priceType.value.priceValue,
          }),
        },
      });
    } else {
      this.dialogRef.close(null);
    }
  }

  getPrice() {
    let framesOutput = [];
    for (let i = 0; i < this.framesList.length; i++) {
      let f = this.framesList[i];
      let price: any = null;
      if (this.formulaForm) {
        price =
          // tslint:disable-next-line: triple-equals
          this.formulaForm.value.priceType.priceValue == 'wholesalePrice' ? f.wholesalePrice : f.purchasePrice;
        if (price) {
          price = price.replace('$', '');
          price = Number(price);
        }
        price = Number(price * this.formulaForm.value.multiplier) + Number(this.formulaForm.value.addition);
        // f.retailPrice = this.replaceEndingDigits(price);
      }
      framesOutput.push(Object.assign({}, f, { retailPrice: this.replaceEndingDigits(price) }));
    }

    return framesOutput;
  }

  replaceEndingDigits(price) {
    const replacer = this.formulaForm.value.replace;
    let priceParts = price.toString().split('.');
    let priceLeftDigits = priceParts[0];
    let priceRightDigits = priceParts[1]?.split("") || [];

    if (replacer) {
      let modifierParts = replacer.split('.');
      const rightModifier = modifierParts[1];
      let leftModifier = modifierParts[0];
      this.endingDigits = replacer;

      if (rightModifier.includes('X')) {
        const idx = rightModifier.search(/[0-9]/);
        if (priceRightDigits.length === 0) {
          priceRightDigits = [rightModifier[idx]];
        } else {
          priceRightDigits[idx] = rightModifier[idx];
        }
      } else {
        priceRightDigits = rightModifier.split('');
      }
      if (leftModifier.length === 1 || leftModifier[1] === 'X') {
        leftModifier = priceLeftDigits[priceLeftDigits.length - 1];
      }

      return `${priceLeftDigits.substring(0, priceLeftDigits.length - 1)}${
        leftModifier[leftModifier.length - 1]
      }.${priceRightDigits.join('')}`;
    }
    return price.toString();
  }

  ngOnInit() {
    this.formulaForm = this.fb.group({
      priceType: [this.priceSelections[0], Validators.required],
      multiplier: ['', [Validators.required, Validators.pattern('^([0-9]{0,2}|[0-9]{0,2}.[0-9]{1,2})$')]],
      addition: ['', [Validators.required, Validators.pattern('^([0-9]{0,3}|[0-9]{0,3}.[0-9]{1,2})$')]],
      replace: [''],
    });
  }
}
